/* eslint-disable import/newline-after-import, import/first */

//region 1. Platform Libraries
import {
        connect,
        createObjectId,
} from 'pow-mongodb-fixtures';
import mongodbURI from 'mongodb-uri';
const request = require('supertest');
//endregion

//region 2. Project Libraries
import DataAPI from '../DataAPI';
//endregion

describe('Route .../event-info', () => {
        const mongo = mongodbURI.parse(process.env.CLIO_MONGO_URL);
        const fixtures = connect(mongo.database, {
                host: mongo.hosts[0].host,
                port: mongo.hosts[0].port,
                user: mongo.username,
                pass: mongo.password,
        });
        const dataAPI = new DataAPI();
        const id = '123456789a123456789b1234';
        const index = 0;

        before(function before(done) {
                this.timeout(5000);
                fixtures.clearAllAndLoad({
                        cameras: [{
                                _id: createObjectId(id),
                                public_address: '123.123.123.123',
                                web_port: 80,
                                username: 'onvif',
                                password: 'onvif',
                                streams: {
                                        0: {
                                                rtsp_url: 'rtsp://url',
                                                rate_control: {
                                                        frame_rate_limit: 30,
                                                },
                                                h264: {
                                                        gov_length: 15,
                                                },
                                        },
                                },
                        }],
                }, (err) => {
                        if (err) {
                                throw new Error(err.message);
                        }
                        dataAPI.initialize({
                                environment: 'unit-test',
                                heartbeatInterval: 10,
                                logLevel: 'DEBUG',
                                mongoUrl: process.env.CLIO_MONGO_URL,
                                port: 15925,
                        });
                        dataAPI.start(done);
                });
        });

        it('GET existing stream should succeed', (done) => {
                request(dataAPI.expressApp)
                .get(`/cameras/${id}/streams/${index}/event-info`)
                .expect(200)
                .end(/** @type function */done);
        });

        after(done => dataAPI.stop(done));
});
